import * as types from '../types'
import store from 'store2'
let interfere = {
  state: {
    test: '123123'
  },
  // mutations: {
  // },
  // actions: {

  // }
  getters: {
    test: (state) => state.test
  }
}

export default interfere



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/modules/interfere.ts